import styles from "./loginotpverifyblock.module.css";
import { useTranslation } from "react-i18next";
import LoginWithGoogleButton from "../LoginWithGoogleButton";
import LoginWithFacebookButton from "../LoginWithFacebookButton";
import LoginWithTiktokButton from "../LoginWithTiktokButton";
import { useState } from "react";
import InputOTP from "../InputOTP";
import VerifyOTPLoginButton from "../VerifyOTPLoginButton";

export default function LoginOTPVerifyBlock({ emailPhoneValue }) {
  const { t } = useTranslation();

  const [errorOTP, setErrorOTP] = useState("");
  const [OTPValue, setOTPValue] = useState("");

  return (
    <div className={styles.loginBlock}>
      <h2 className={styles.loginText}>{t("login")}</h2>
      <div className={`col-11 ${styles.inputBlock}`}>
        <div className={`col-11 ${styles.inputContainer}`}>
          <InputOTP
            OTPValue={OTPValue}
            setOTPValue={setOTPValue}
          />
        </div>
        <span className={styles.errorText}>{t(errorOTP)}</span>
      </div>
      <div className={`col-12 ${styles.loginButtonContainer}`}>
        <VerifyOTPLoginButton
          errorOTP={errorOTP}
          OTPValue={OTPValue}
          emailPhoneValue={emailPhoneValue}
          setErrorOTP={setErrorOTP}
          navigateTo={"/home"}
        />
      </div>
      <div className={styles.linkBlock}>
        <a href="login">{t("login_with_password")}</a>
      </div>
      <div className={`col-12 ${styles.hrContainer}`}>
        <hr className={styles.leftHr} />
        <span className={styles.hrText}>{t("or")}</span>
        <hr className={styles.rightHr} />
      </div>
      <div className={`col-12 ${styles.loginWithBlock}`}>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithGoogleButton />
        </div>
        <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithFacebookButton />
        </div>
        {/* <div className={`col-9 ${styles.loginWithContainer}`}>
          <LoginWithTiktokButton />
        </div> */}
      </div>
      <p className="col-12 d-flex justify-content-center">
        {t("first_time_bhive")} <a href="/signup">{t("signup")}</a>
      </p>
    </div>
  );
}
